module.exports = __webpack_public_path__ + "img/img_background_leading@2x.8283019b.png";